// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"312":"e2caec74","791":"46d3abd4"}[chunkId] + ".css";
};